import { ApplicationEvent } from './application-event.model';
import { ApplicationEventType } from '../constants';
import { ValidationError } from '~shared/models';

export class CheckoutErrorsApplicationEvent implements ApplicationEvent {

  type = ApplicationEventType.CheckoutErrors;

  constructor(
    private errors: ValidationError[]) {

  }

  getPayload(): any {
    return {
      errors: this.errors
    };
  }
}
